import { useMemo } from "react"

const useOrderedCart = cart => {
  const orderedCart = useMemo(() => {
    const ordered = []

    if (!cart) return

    cart.products.forEach(item => {
      if (item.parentId) return

      const extensions = cart.products.filter(
        extension => extension.parentId === item.productId
      )

      if (extensions.length) item.extensions = extensions

      ordered.push(item)
    })

    return ordered
  }, [cart])

  return orderedCart
}

export default useOrderedCart
